module.exports = __webpack_public_path__ + "static/media/completed pin.358c4111.svg";